import { useState, useEffect } from "react";
import { Card, Typography } from "@mui/material";
import { styles } from "../theme/styles";
import { Creators } from "../store/ducks/users";
import { connect } from "react-redux";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Cliploader from "./Cliploader";
import CamaraComponent from "./CamaraComponent.js";
import Swal from "sweetalert2";
import { CustomButton } from "./CustomButton.js";

const PassForm = () => {
  const { idOrder } = useParams();
  const [jsonInfo, setJsonInfo] = useState([]);
  const [mongoData, setMongoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState("");
  const [selectedMaterialDescr, setSelectedMaterialDescr] = useState("");
  const [mostrarCamara, setMostrarCamara] = useState(false);
  const navigate = useNavigate();
  const formattedDate = new Date().toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  console.log("MONGO DATA", mongoData);
  console.log("SELECTED MATERIAL", selectedMaterial);

  const getInfoOrderMongo = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getInfoOrderMongo`,
        { idOrder: idOrder },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setLoading(false);
      setJsonInfo(data.data.jsonInformacion);
      let versionEvidenciaActual = data.data.evidencias;
      setMongoData({
        ...data.data,
        evidencias: versionEvidenciaActual ? versionEvidenciaActual : [],
      });
    } catch (error) {
      setLoading(false);
      console.error("Error al obtener info de mongo:", error);
    }
  };

  useEffect(() => {
    getInfoOrderMongo();
  }, [mostrarCamara]);

  const generateExcel = async (e) => {
    e.preventDefault();

    // Verificar que exista al menos un material con fotos
    if (
      mongoData.evidencias &&
      Array.isArray(mongoData.evidencias) &&
      mongoData.evidencias.length > 0
    ) {
      const existeAlMenosUnaFoto = mongoData.evidencias.some(
        (ev) => ev.fotos && ev.fotos.length > 0,
      );

      if (!existeAlMenosUnaFoto) {
        Swal.fire({
          icon: "error",
          title: "Faltan fotografías",
          text: "Debes subir al menos una foto en cualquier material",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Aceptar",
        });
        return; // Detén el proceso
      }
    } else {
      // Si no hay evidencias en absoluto
      Swal.fire({
        icon: "error",
        title: "Faltan fotografías",
        text: "Debes subir al menos una foto en cualquier material",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/generarFormatoExcel`,
        { idOrder: idOrder, tipoReporte: "1" },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Formato generado correctamente",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/reporterecepcion");
          setLoading(false);
        }
      });
    } catch (error) {
      console.log("Error: ", error);
      setLoading(false);
    }
  };

  return (
    <div className="div-reporte-table">
      <Cliploader loading={loading} />

      <Typography
        variant="h6"
        justifyContent="center"
        color="#00205b"
        style={styles.titleaux}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            {" "}
            {formattedDate}
          </span>
          &nbsp;&nbsp; REPORTE DE RECEPCIÓN&nbsp;&nbsp;{" "}
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            ORDEN &nbsp;
            {idOrder}
          </span>
        </div>
      </Typography>

      <div style={{ width: "100%", height: "100%" }}>
        <svg
          style={{
            cursor: "pointer",
            marginTop: "-5px",
            marginBottom: "-10px",
          }}
          onClick={() => navigate(`/reporterecepcionExcel/${idOrder}`)}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#00205b"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M5 12l14 0" />
          <path d="M5 12l6 6" />
          <path d="M5 12l6 -6" />
        </svg>
        <p className="card-repo">
          <span style={{ color: "#C53030" }}>
            ⚠️ <strong>RECUERDA:</strong>{" "}
          </span>
          <span> El </span>
          <strong>reporte de recepción</strong> deberá generarse{" "}
          <strong style={{ color: "#004AAD" }}>de forma inmediata</strong> al
          momento de recibir el pedido.
          <br />
          <br />
          Posteriormente, será necesario{" "}
          <strong>dar seguimiento al mismo reporte</strong> dentro de un periodo
          máximo de <strong style={{ color: "#D97706" }}>24 horas</strong> para{" "}
          <strong>alimento vivo y congelado</strong>, y de{" "}
          <strong style={{ color: "#D97706" }}>48 horas</strong> para{" "}
          <strong>peces y animales</strong>, registrando las observaciones o
          actualizaciones correspondientes.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}>
          <div className="table-ev">
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
              }}>
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th className="head-table-evidencias">Seleccionar</th>
                  <th className="head-table-evidencias">Material</th>
                  <th className="head-table-evidencias">Evidencia</th>
                  <th className="head-table-evidencias">Fotos</th>
                  <th className="head-table-evidencias">Agregar evidencia</th>
                </tr>
              </thead>
              <tbody>
                {jsonInfo
                  .filter((item) => item.materialId !== "")
                  .map((item) => {
                    const evidencia = mongoData?.evidencias?.find(
                      (e) => e.material === item.materialId,
                    );
                    const tieneEvidencias =
                      evidencia && evidencia.fotos.length > 0;
                    return (
                      <tr
                        key={item.materialId}
                        style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ textAlign: "center", padding: "8px" }}>
                          <input
                            type="radio"
                            name="material"
                            value={item.materialId}
                            checked={selectedMaterial === item.materialId}
                            onChange={() => {
                              setSelectedMaterial(item.materialId);
                              setSelectedMaterialDescr(
                                item.materialDescripcion,
                              );
                            }}
                          />
                        </td>
                        <td style={{ padding: "8px" }}>
                          {item.manual ? "🖐 " : ""}
                          {item.materialId} - {item.materialDescripcion}
                        </td>
                        <td style={{ textAlign: "center", padding: "8px" }}>
                          <span
                            style={{
                              color: tieneEvidencias ? "green" : "red",
                              fontWeight: "bold",
                            }}>
                            {tieneEvidencias ? "Cargada" : "Cargar evidencia"}
                          </span>
                        </td>
                        <td style={{ padding: "8px" }}>
                          {tieneEvidencias ? (
                            <div
                              style={{
                                display: "flex",
                                gap: "4px",
                                flexWrap: "wrap",
                              }}>
                              {evidencia.fotos.map((foto, i) => (
                                <figure key={i} className="div-evidencias">
                                  <img
                                    src={foto.url}
                                    alt={`evidencia-${i}`}
                                    style={{
                                      width: "50px",
                                      height: "35px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                      display: "block",
                                    }}
                                  />
                                  <figcaption
                                    style={{ fontSize: "10px", color: "#555" }}>
                                    {foto.descripcionFoto}
                                  </figcaption>
                                </figure>
                              ))}
                            </div>
                          ) : (
                            <span style={{ fontSize: "12px", color: "#666" }}>
                              Sin evidencias
                            </span>
                          )}
                        </td>

                        <td
                          style={{
                            textAlign: "center",
                            padding: "8px",
                            cursor: "pointer",
                          }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#00205B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            onClick={() => {
                              setSelectedMaterial(item.materialId);
                              setSelectedMaterialDescr(
                                item.materialDescripcion,
                              );
                              setMostrarCamara(true);
                            }}>
                            <path d="M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5" />
                            <path d="M16 19h6" />
                            <path d="M19 16v6" />
                            <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                          </svg>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div>
        <CustomButton onClick={generateExcel}>
          Enviar para validación
        </CustomButton>
      </div>

      {mostrarCamara && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}>
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
              background: "white",
              borderRadius: "10px",
              padding: "1rem",
              position: "relative",
            }}>
            <svg
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                cursor: "pointer",
              }}
              onClick={() => setMostrarCamara(false)}
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff3b30"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path d="M10 10l4 4m0 -4l-4 4" />
              <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
            </svg>
            <CamaraComponent
              selectedMaterial={selectedMaterial}
              selectedMaterialDescr={selectedMaterialDescr}
              onPhotosChange={(photos) => {
                getInfoOrderMongo();
              }}
              mongoData={mongoData}
              onClose={() => setMostrarCamara(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  menu: state.users.menu,
  userData: state.users.data,
  idNumber: state.users.idNumber,
  token: state.users.uid,
  loading: state.users.loading,
  message: state.config.message,
});
const creators = {
  logout: Creators.logout,
  changePassword: Creators.changePassword,
  clearMessage: CreatorsConfig.clearMessage,
};
export default connect(mapStateToProps, creators)(PassForm);
